<template>
    <lb-drawer
        data-testid="transaction-matching-config-new__filter-properties-drawer"
        :value="dialog"
        @input="$emit('update:dialog', $event)"
        :heading="heading || 'Filter properties'"
        width="600"
        :loading="loading"
    >
        <template v-slot:body>
            <v-row>
                <div class="mb-5 ml-3">
                    <span class=""> Select Filter : <span class="font-weight-black">{{ filterInfo.column }} </span></span>
                    <span class="mb-3"> Type : <span class="font-weight-black">{{ filterInfo.type }} </span></span>
                </div>
                <!-- Number Filter -->
                <v-col cols="12" class="my-0 py-1" v-if="filterInfo.type === 'Number'">
                    <lb-dropdown
                        data-testid="transaction-matching-config-new__filter-operation-dropdown"
                        label="Select Operation"
                        :items="itemsNumber"
                        v-model="filterObject.operation"
                        :error="errorObject.operation"
                    />
                    <lb-number
                        data-testid="transaction-matching-config-new__filter-range1-input"
                        label="Range 1"
                        :items="itemsNumber"
                        v-model="filterObject.range1"
                        :error="errorObject.range1"
                    />
                    <lb-number
                        data-testid="transaction-matching-config-new__filter-range2-input"
                        label="Range 2"
                        :items="itemsNumber"
                        v-model="filterObject.range2"
                        :error="errorObject.range2"
                        v-if="filterObject.operation === 'Between' && filterInfo.type === 'Number'"
                    />
                </v-col>

                <!-- Text Filter -->
                <v-col cols="12" class="my-0 py-1" v-if="filterInfo.type === 'Text'">
                    <lb-dropdown
                        data-testid="transaction-matching-config-new__filter-operation-dropdown"
                        label="Select Operation"
                        :items="itemsString"
                        v-model="filterObject.operation"
                        :error="errorObject.operation"
                    />
                    <lb-string
                        data-testid="transaction-matching-config-new__filter-range-input"
                        label="Range"
                        v-model="filterObject.range"
                        :error="errorObject.range"
                    />
                </v-col>

                <!-- Date Filter -->
                <v-col cols="12" class="my-0 py-1" v-if="filterInfo.type === 'Date'">
                    <lb-dropdown
                        data-testid="transaction-matching-config-new__filter-operation-dropdown"
                        label="Select Operation"
                        :items="itemsDate"
                        v-model="filterObject.operation"
                        :error="errorObject.operation"
                    />
                    <lb-date
                        data-testid="transaction-matching-config-new__filter-range1-input"
                        label="Range 1"
                        v-model="filterObject.range1"
                        :error="errorObject.range1"
                    />
                    <lb-date
                        data-testid="transaction-matching-config-new__filter-range2-input"
                        label="Range 2"
                        v-model="filterObject.range2"
                        :error="errorObject.range2"
                        v-if="filterObject.operation === 'Between' && filterInfo.type === 'Date'"
                    />
                </v-col>
            </v-row>

            <div class="d-flex align-center gap-2">
                <v-spacer></v-spacer>
                <v-btn
                    data-testid="transaction-matching-config-new__filter-clear-button"
                    color="primary"
                    class="shadow-off"
                    @click="$emit('clear')"
                >
                    <span>Clear Filter</span>
                </v-btn>
                <v-btn
                    data-testid="transaction-matching-config-new__filter-add-button"
                    color="primary"
                    class="shadow-off"
                    @click="$emit('add')"
                >
                    <span>Add Filter</span>
                </v-btn>
            </div>

            <v-simple-table
                data-testid="transaction-matching-config-new__filter-list-table"
                dense
                class="border-on"
                v-if="filterList.length > 0"
            >
                <template v-slot:default>
                    <thead class="tableHeaderBg">
                        <tr>
                            <th class="text-left tableHeaderBg ellipsis-on" id="sequence">Sequence</th>
                            <th class="text-left tableHeaderBg ellipsis-on" id="column">Column</th>
                            <th class="text-left tableHeaderBg ellipsis-on" id="operation">Operation</th>
                            <th class="text-left tableHeaderBg ellipsis-on" id="range1">Criteria 1</th>
                            <th class="text-left tableHeaderBg ellipsis-on" id="range2">Criteria 2</th>
                            <th class="text-left tableHeaderBg" id="type">Type</th>
                            <th class="text-left tableHeaderBg" id="action">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in filterList" :key="index" :id="'automation-test-'+index">
                            <td :id="'automation-test-'+index">{{ index + 1 }}</td>
                            <td :id="'automation-test-'+index">{{ item.column }}</td>
                            <td :id="'automation-test-'+index">{{ item.operation }}</td>
                            <td :id="'automation-test-'+index">{{ formatValue(item.value1 || item.range, item.type) }}</td>
                            <td :id="'automation-test-'+index">{{ formatValue(item.value2, item.type) }}</td>
                            <td :id="'automation-test-'+index">{{ item.type }}</td>
                            <td :id="'automation-test-'+index">
                                <v-btn icon color="error" @click="$emit('delete', index)">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </template>
    </lb-drawer>
</template>

<script>
export default {
    name: 'FilterPropertiesDrawer',
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        heading: {
            type: String,
            default: 'Filter properties'
        },
        filterInfo: {
            type: Object,
            default: () => ({ column: '', type: '' }),
            required: true
        },
        filterObject: {
            type: Object,
            required: true
        },
        errorObject: {
            type: Object,
            default: () => ({})
        },
        itemsNumber: {
            type: Array,
            default: () => []
        },
        itemsString: {
            type: Array,
            default: () => []
        },
        itemsDate: {
            type: Array,
            default: () => []
        },
        filterList: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        formatValue(value, type) {
            if (!value) return '';
            // If type is Date, try to format. Otherwise return as is (for Number/Text)
            if (type === 'Date') {
                // Assuming $nova is available formatted date
                return this.$nova ? this.$nova.formatDate(value) : value; 
            }
            return value;
        }
    }
};
</script>